module.exports = __webpack_public_path__ + "static/media/jallu.3e0bca87.png";


//////////////////
// WEBPACK FOOTER
// ./src/jallu.png
// module id = 253
// module chunks = 0